import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";
import { BsBuildings } from "react-icons/bs";
import { CiBoxList } from "react-icons/ci";
import { GoShieldLock, GoShieldCheck } from "react-icons/go";
import { HiOutlineCog8Tooth } from "react-icons/hi2";
import { LuCreditCard, LuFileText } from "react-icons/lu";
import { MdPeopleOutline, MdOutlineLink } from "react-icons/md";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import sidebar from "../../utils/sidebar";
import PageSubHeader from "../../../../components/Layouts/PageSubHeader";
import { useTranslation } from "react-i18next";
import "./styles.css";
import { FaFacebook, FaInstagram, FaLinkedin, FaSnapchat, FaTiktok, FaXTwitter, FaYoutube } from "react-icons/fa6";

function HomePage() {
  const { t } = useTranslation();

  const shortcuts = [
    { titleKey: "sidebar.company",         icon: <BsBuildings />,        link: "/settings/company" },
    { titleKey: "sidebar.users",           icon: <MdPeopleOutline />,    link: "/settings/users" },
    { titleKey: "sidebar.rolesPermissions",icon: <CiBoxList />,          link: "/settings/roles" },
    { titleKey: "sidebar.preferences",     icon: <HiOutlineCog8Tooth />, link: "/settings/preferences" },
    { titleKey: "sidebar.integrations",    icon: <MdOutlineLink />,      link: "/settings/integrations" },
    { titleKey: "settings.security",       icon: <GoShieldLock />,       link: "/settings/security" },
    { titleKey: "sidebar.billingSub",      icon: <LuCreditCard />,       link: "/settings/billing" },
    { titleKey: "sidebar.auditLogs",       icon: <LuFileText />,         link: "/settings/audit-logs" },
  ];

  return (
    <SidebarLayout sidebar={sidebar}>
      <div className="page-with-subheader">
        <PageSubHeader title={t('settings.title')} />

        <div className="subheader-page-content scrollable">
          <div className="alert alert-success mb-3">
            <span className="alert-icon"><GoShieldCheck /></span>
            <span>
              <span className="alert-label">{t('settings.security')}:</span>
              {t('settings.noSecurityActions')}
            </span>
          </div>

          {/* Quick-access cards */}
          <Row className="g-3">
            {shortcuts.map((item) => (
              <Col key={item.link} xs={12} sm={6} md={4} lg={3}>
                <Link to={item.link} className="settings-card">
                  <div className="settings-card-icon">{item.icon}</div>
                  <p className="settings-card-title">{t(item.titleKey)}</p>
                </Link>
              </Col>
            ))}
          </Row>

          <div className="d-flex justify-content-center gap-3 mt-5">
            <a href="https://facebook.com/nazarcloud" target="_blank">
              <FaFacebook size={24} color="#3b5998" />
            </a>
            <a href="https://instagram.com/nazar.cloud" target="_blank">
              <FaInstagram size={24} color="#E1306C" />
            </a>
            <a href="https://linkedin.com/company/nazarcloud" target="_blank">
              <FaLinkedin size={24} color="#0077B5" />
            </a>
            <a href="https://x.com/nazarerp" target="_blank">
              <FaXTwitter size={24} color="#000" />
            </a>
            <a href="https://youtube.com/@nazarcloud" target="_blank">
              <FaYoutube size={24} color="#FF0000" />
            </a>
            <a href="https://tiktok.com/@nazarcloud" target="_blank">
              <FaTiktok size={24} color="#000000" />
            </a>
            <a href="https://www.snapchat.com/@nazarcloud" target="_blank">
              <FaSnapchat size={24} color="#77751a" />
            </a>
          </div>
        </div>
      </div>
    </SidebarLayout>
  );
}

export default HomePage;
